import { useVacancyApi } from "../../apis/vacancy-api";
import useAuthData from "../../auth/useAuthData";
import EditableInput from "../../components/ui-lib/EditableInput";
import { TextArea } from "../../components/ui-lib/TextArea";
import {
  removeDuplicates,
  removeDuplicatesSimple,
} from "../../helpers/utils/array.util";
import { absenceReasonMapper, Vacancy } from "../../models/vacancy/vacancy";

function VacancyDetailDisplay({ vacancy }: { vacancy: Vacancy }) {
  const { currentSchool } = useAuthData();
  const { updateVacancy } = useVacancyApi();

  const onUpdateDescription = async (description: string) => {
    if (!currentSchool) return;
    await updateVacancy(vacancy.id, currentSchool?.id, {
      ...Vacancy.toUpdateDto(vacancy),
      description,
    });
  };

  return (
    <>
      <div className="lg:flex">
        <div className="mb-2 grid flex-1 grid-cols-2 gap-2">
          <span className="font-bold">Status:</span>
          <span>
            {
              vacancy.lessons.filter((lesson) => !!lesson.teacherAccepted)
                .length
            }{" "}
            von {vacancy.lessons.length} Lektionen besetzt
          </span>
          <span className="font-bold">Schulhaus:</span>
          <span>{vacancy.subSchools.map((s) => s.name).join(", ")}</span>
          <span className="font-bold">Klassen:</span>
          <span>
            {removeDuplicatesSimple(
              vacancy.lessons.map((l) => l.className),
            ).join(", ")}
          </span>
          <span className="font-bold">Lehrperson:</span>
          <span>{vacancy.absentTeacher.fullName}</span>
          <span className="font-bold">Ausfallgrund:</span>
          <span>{absenceReasonMapper(vacancy.absenceReason)}</span>
        </div>
        <div className="grid flex-1 grid-cols-2 gap-2 self-baseline">
          {(vacancy.teacherAccepted?.length ?? 0) > 0 && (
            <span className="font-bold">Vertretung:</span>
          )}
          {(vacancy.teacherAccepted?.length ?? 0) > 0 && (
            <span>
              {vacancy.teacherAccepted
                ?.map((teacher) => `${teacher.name} ${teacher.lastname}`)
                .join(", ")}
            </span>
          )}
          <div className="col-span-2 flex flex-col">
            <span className="font-bold">Fächer:</span>
            <div className="mt-2 flex flex-wrap">
              {removeDuplicates(vacancy.lessons, "name")
                .filter((lesson) => !!lesson.name)
                .map((lesson) => (
                  <div
                    key={lesson.name}
                    className="mb-2 mr-2 rounded-md bg-th-primary-900 px-4 py-1 text-white"
                  >
                    {lesson.name}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 grid grid-cols-2 break-words lg:grid-cols-4">
        <strong>Beschreibung:</strong>
        <EditableInput
          className="lg:col-span-3"
          initialValue={vacancy.description}
          placeholder="Beschreibung bearbeiten"
          onConfirm={onUpdateDescription}
          useEnterToConfirm={false}
          renderInput={(props) => (
            <TextArea
              name="Beschreibung"
              label="Beschreibung"
              id="description"
              rows={6}
              {...props}
            />
          )}
        ></EditableInput>
      </div>
    </>
  );
}

export default VacancyDetailDisplay;
